import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrganisationService {

  constructor(private http: HttpClient) { }

  getOrganisation(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/setups/organisation/get_organisations`);
  }

  getOrgType(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_org_type`);
  }

  addOrg(req): Observable<any[]> {
    console.log(req);
    const formData = new FormData();
    formData.append('org_name', req.org_name);
    formData.append('org_logo', req.org_logo);
    formData.append('org_website', req.org_website);
    formData.append('org_curr', req.org_curr);
    formData.append('org_type', req.org_type);
    formData.append('org_industry_type', req.org_industry_type);
    formData.append('org_gst', req.org_gst);
    formData.append('org_pan', req.org_pan);
    formData.append('org_id', req.org_id);
    formData.append('org_cn', req.org_cn);
    if (!req.org_id) {
      return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/add_organisation`, formData);
    } else {
      return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/edit_organisation_action`, formData);
    }
  }

  editOrganisation(orgid): Observable<any[]> {
    console.log(orgid);
    return this.http.get<any[]>(`${environment.apiUrl}/setups/organisation/edit_organisation/` + orgid);
  }

  editAddress(addid): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/edit_address/` + addid);
  }

  deleteOrganisation(orgid): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/delete_organisation`, {org_id: orgid});
  }

  changeOrganisationStatus(orgid, stat): Observable<any[]> {
    const option = {
      status: stat,
      org_id : orgid
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(`${environment.apiUrl}/setups/organisation/edit_organisation_status_action`, options);
  }

  getOrganizationDetail(orid): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/setups/organisation/organisation-details/` + orid);
  }

  getPlantDetail(orid): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/setups/organisation/get_plants/` + orid);
  }

  getSearchPlant(orgid, plID): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/get_plants/${orgid}`, plID);
  }

  paginate(orgid, limit): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/get_plants/${orgid}`, limit);
  }

  editPlant(id): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/setups/organisation/edit_plant/` + id);
  }

  addPlant(req): Observable<any[]> {
    console.log(req);
    const formData = new FormData();
    // formData.append('pl_id', req.org_id);
    formData.append('pl_id', req.pl_id);
    formData.append('pl_logo', req.pl_logo);
    formData.append('pl_name', req.pl_name);
    formData.append('pl_industry_id', req.pl_industry_id);
    formData.append('pl_curr', req.pl_curr);
    formData.append('org_id', req.org_id);
    formData.append('pl_code', req.pl_code);
    formData.append('pf_type', req.pf_type);
    formData.append('segment_id', req.segment_id);
    formData.append('sub_segment_id', req.sub_segment_id);
    formData.append('budg_headcount', req.budg_headcount);
    formData.append('curr_headcount', req.curr_headcount);
    formData.append('business_entity', req.business_entity);
    formData.append('payroll_category', req.payroll_category);
    formData.append('payroll_condition', req.payroll_condition);
    formData.append('esic_location', req.esic_location);
    formData.append('esic_sublocation', req.esic_sublocation);
    formData.append('esic_applicable', req.esic_applicable);
    formData.append('pf_code', req.pf_code);
    formData.append('is_ftc_leave_access', req.is_ftc_leave_access);
    formData.append('site_type', req.site_type);
    formData.append('pincode_cluster', req.pincode_cluster);
    formData.append('FOSTAC', req.FOSTAC);
    formData.append('sch_emp', req.sch_emp);
    formData.append('zone', req.zone);
    formData.append('monthly_bonus', req.monthly_bonus);
    formData.append('is_base_offc', req.is_base_offc);
    formData.append('is_tchncn_reqd', req.is_tchncn_reqd);
    formData.append('service_type', req.service_type);
    formData.append('is_sgna_site', req.is_sgna_site);

    formData.append('total_hour', req.total_hour);
    formData.append('present', req.present);
    formData.append('halfday', req.halfday);
    formData.append('present_allowance', req.present_allowance);
    formData.append('absent_allownce', req.absent_allownce);
    


    if(req.is_ot == false) {
      req.ot_limit =  0;
    }
    if(req.is_a_p_att == true){
      req.is_a_p_att = 1;
    }else{
      req.is_a_p_att = 0;
    }

    if(req.is_in_out1 == true){
      req.is_in_out1 = 1;
    }else{
      req.is_in_out1 = 0;
    }

    if(req.is_in_out2 == true){
      req.is_in_out2 = 1;
    }else{
      req.is_in_out2 = 0;
    }

    if(req.is_in_out3 == true){
      req.is_in_out3 = 1;
    }else{
      req.is_in_out3 = 0;
    }

    if(req.is_ot == true){
      req.is_ot = 1;
    }else{
      req.is_ot = 0;
    }

    formData.append('is_a_p_att', req.is_a_p_att);
    formData.append('is_in_out1', req.is_in_out1);
    formData.append('is_in_out2', req.is_in_out2);
    formData.append('is_in_out3', req.is_in_out3);
    formData.append('is_ot', req.is_ot);
    formData.append('ot_limit', req.ot_limit);

    if (!req.pl_id) {
      return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/add_plant`, formData);
    } else {
      return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/edit_plant_action`, formData);

    }
  }

  deletePlant(id): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/delete_plant`, {pl_id: id});
  }

  changePlantStatus(id, stat): Observable<any[]> {
    const option = {
      status: stat,
      pl_id : id
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(`${environment.apiUrl}/setups/organisation/edit_plant_status_action`, options);
  }

  addAddress(req): Observable<any[]> {
    console.log(req);
    if (!req.add_id) {
      return this.http.post<any[]>(`${environment.apiUrl}/add_address`, req);
    } else {
      return this.http.post<any[]>(`${environment.apiUrl}/edit_address_action`, req);
    }
  }

  addContact(req): Observable<any[]> {
    console.log(req);
    if (!req.cont_id) {
      return this.http.post<any[]>(`${environment.apiUrl}/add_contact`, req);
    } else {
      return this.http.post<any[]>(`${environment.apiUrl}/edit_contact_action`, req);
    }
  }

  editContact(conid): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/edit_contact/` + conid);
  }

  deleteContact(id): Observable<any[]> {
    return this.http.delete<any[]>(`${environment.apiUrl}/delete_contact/` + id);
  }

  addFinance(req, finId): Observable<any[]> {
    console.log(req);
    if (finId == '' || finId == null || finId == 'undefined') {
      return this.http.post<any[]>(`${environment.apiUrl}/add_finance`, req);
    } else {
      return this.http.post<any[]>(`${environment.apiUrl}/edit_finance_action`, req);
    }
  }

  editFinance(id): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/edit_finance/` + id);
  }

  deleteFinance(id): Observable<any[]> {
    return this.http.delete<any[]>(`${environment.apiUrl}/delete_finance/` + id);
  }

  getProfitCenter(id, data): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/get_profit_centers/${id}`, data);
  }

  addProfitCenter(req): Observable<any[]> {
    console.log(req);
    if (!req.pc_id) {
      return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/add_profit_center`, req);
    } else {
      return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/edit_profit_center_action`, req);
    }
  }

  deleteProfitCenter(id): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/delete_profit_center`, {pc_id: id});
  }

  editProfitCenter(id): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/setups/organisation/edit_profit_center/` + id);
  }

  changeProfitCenterStatus(id, stat): Observable<any[]> {
    const option = {
      status: stat,
      pc_id : id
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(`${environment.apiUrl}/setups/organisation/edit_profit_center_status_action`, options);
  }

  getCostCenter(id, data): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/get_cost_centers/${id}` , data);
  }

  addCostCenter(req): Observable<any[]> {
    console.log(req);
    if (!req.cc_id) {
      return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/add_cost_center`, req);
    } else {
      return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/edit_cost_center_action`, req);
    }
  }

  editCostCenter(id): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/setups/organisation/edit_cost_center/` + id);
  }

  deleteCostCenter(id): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/delete_cost_center`, {cc_id: id});
  }

  changeCostCenterStatus(id, stat): Observable<any[]> {
    const option = {
      status: stat,
      cc_id : id
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(`${environment.apiUrl}/setups/organisation/edit_cost_center_status_action`, options);
  }

  getWarehouse(id): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/setups/organisation/get_warehouse/` + id);
  }

  addWarehouse(req): Observable<any[]> {
    console.log(req);
    if (!req.wh_id) {
      return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/add_warehouse`, req);
    } else {
      return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/edit_warehouse_action`, req);
    }
  }

  editWarehouse(id): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/setups/organisation/edit_warehouse/` + id);
  }

  deleteWarehouse(id): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/delete_warehouse`,{wh_id: id});
  }

  changeWarehouseStatus(id, stat): Observable<any[]> {
    const option = {
      status: stat,
      wh_id : id
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(`${environment.apiUrl}/setups/organisation/edit_warehouse_status_action`, options);
  }

  addWhLocation(req): Observable<any[]> {
    console.log(req);
    if (!req.whloc_id) {
      return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/add_warehouse_location`, req);
    } else {
      return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/edit_warehouse_location_action`, req);
    }
  }

  getWhLocation(id): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/setups/organisation/get_warehouse_locations/` + id);
  }

  editWhlocation(id): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/setups/organisation/edit_warehouse_location/` + id);
  }

  deleteWhLocatioin(id): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/delete_warehouse_location`, {whloc_id: id});
  }

  changeWhLocationStatus(id, stat): Observable<any[]> {
    const option = {
      status: stat,
      whloc_id : id
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(`${environment.apiUrl}/setups/organisation/edit_warehouse_location_status_action`, options);
  }

  getPlantsFullDetails(id): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/setups/organisation/get_plant_details/` + id);
  }

  getOrganisationFullDetails(id): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/setups/organisation/get_org_warehouse/` + id);
  }


  getSegment(): Observable<any> {
    return this.http.post(`${environment.apiUrl}/setups/organisation/get_segments`, []);
  }

  editSegStatus(stat, segID): Observable<any> {
    const option = {
      status: stat,
      segment_id : segID
  };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(`${environment.apiUrl}/setups/organisation/edit_segment_status_action`, options);
  }

  editSegment(segID): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/setups/organisation/edit_segments/` + segID);
  }

  deleteSegment(segId): Observable<any> {
    return this.http.post(`${environment.apiUrl}/setups/organisation/delete_segment`, {segment_id: segId});
  }

  addSegment(data: FormData, segID): Observable<any> {
    if (!segID) {
      return this.http.post<any>(`${environment.apiUrl}/setups/organisation/add_segments`, data);
    } else {
      return this.http.post<any>(`${environment.apiUrl}/setups/organisation/edit_segments_action`, data);
    }
  }

  getsubSegment(data): Observable<any> {
    return this.http.post(`${environment.apiUrl}/setups/organisation/get_sub_segments`, data);
  }

  editsubSegStatus(stat, subSegID): Observable<any> {
    const option = {
      status: stat,
      sub_segment_id : subSegID
  };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(`${environment.apiUrl}/setups/organisation/edit_sub_segment_status_action`, options);
  }

  editsubSegment(subSegID): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/setups/organisation/edit_sub_segment/` + subSegID);
  }

  deletesubSegment(subSegId): Observable<any> {
    return this.http.post(`${environment.apiUrl}/setups/organisation/delete_subsegment`, {sub_seg_id: subSegId});
  }

  addsubSegment(data: FormData, subSegID): Observable<any> {
    if (!subSegID) {
      return this.http.post<any>(`${environment.apiUrl}/setups/organisation/add_sub_segment`, data);
    } else {
      return this.http.post<any>(`${environment.apiUrl}/setups/organisation/edit_sub_segments_action`, data);
    }
  }

  getPlantRole(data): Observable<any> {
    return this.http.post(`${environment.apiUrl}/setups/organisation/get_plant_role`, data);
  }
  updatePlantRole(data): Observable<any> {
    return this.http.post(`${environment.apiUrl}/setups/organisation/update_plant_role`, data);
  }
  deletePlantRole(data): Observable<any> {
    return this.http.post(`${environment.apiUrl}/setups/organisation/delete_plant_role`, data);
  }
  getPlantTeams(plID,appID): Observable<any> {
    return this.http.get(`${environment.apiUrl}/setups/organisation/get_plant_teams/` + plID + '/' + appID);
  }
  addPlantTeams(req): Observable<any> {
    return this.http.post(`${environment.apiUrl}/setups/organisation/add_plant_teams` , req);
  }
  deletePlantTeams(req): Observable<any> {
    return this.http.post(`${environment.apiUrl}/setups/organisation/delete_plant_teams` , req);
  }
  updateStatusPlantTeams(req): Observable<any> {
    return this.http.post(`${environment.apiUrl}/setups/organisation/update_status_plant_teams` , req);
  }

  getOrgCycle(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get(`${environment.apiUrl}/setups/organisation/get_org_cycle`,{params:param});
  }

  getCostCenterFin(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(`${environment.apiUrl}/setups/organisation/get_cost_centers_fin` , {params:param});
  }

  addPlantFin(data): Observable<any> {
      return this.http.post<any>(`${environment.apiUrl}/setups/organisation/add_plant_fin`, data);
  }

  updatePlantFin(data): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/setups/organisation/edit_plant_action_fin`, data);
  }

  deletePlantFin(id): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/setups/organisation/delete_plant_fin`, {pl_id: id});
  }

  editPlantFin(id): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/setups/organisation/edit_plant_fin/` + id);
  }

  getLoactions(data): Observable<any>{
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/setups/organisation/get_locations`,
      { params: param }
    );
  }
  editLocationStatusAction(stat, id): Observable<any> {
    const option = {
        status: stat,
        location_id : id
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(`${environment.apiUrl}/setups/organisation/edit_location_status_action`, options);
  }
  deleteLocationAction( id): Observable<any> {
    const option = {
        location_id : id
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(`${environment.apiUrl}/setups/organisation/delete_location_action`, options);
  }
  generateQRCode(id,data,column): Observable<any> {
    const option = {
        loc_id : id,
        building_desc :data.building_desc,
        floor_desc :data.floor_desc,
        location_desc :data.location_desc,
        column,
        env: environment.apiUrl
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(`${environment.apiUrl}/setups/organisation/create_location_qr_code`, options);
  }

  addLocation(data): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/setups/organisation/add_location`, data);
  }

  editLocation(locationID): Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}/setups/organisation/edit_location/`+ locationID);
  }

  //Shift

  addShift(data: FormData, ID=''): Observable<any> {
    if (!ID) {
      return this.http.post<any>(
        `${environment.apiUrl}/setups/organisation/add`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/setups/organisation/edit/submit`,
        data
      );
    }
  }

  deleteShift(Id): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/del`, {id: Id});
  }

  geteditShift(id): Observable<any[]> {
    const option = {
      id : id
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any[]>(`${environment.apiUrl}/setups/organisation/edit/get`,options);
  }

  switchShift(status, Id): Observable<any> {
    const option = {
      status: status,
      id : Id
    };
    const item = new HttpParams({ fromObject: option });
    return this.http.post<any>(`${environment.apiUrl}/setups/organisation/update/status`, item);
  }
  // end

      // Meal Type Mapping
  getShiftdta(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/setups/organisation/list`,
      { params: param }
    );
  }

  getShiftDown(ID, data={}): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }

    return this.http.get<any[]>(
      `${environment.apiUrl}/setups/organisation/shift_dropdown/` + ID,
      {params:param}
    );
  }

  getShiftDropDown(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/setups/organisation/shift_dropdown_val`
    );
  }




}
